import React from 'react';
import { MediaElement, MediaElementModel, ModuleSection } from '@/components';
import { ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import classNames from 'classnames';

type ImageVideoX2BlockModel = ModuleBaseModel<
  {
    leftMediaSection: MediaElementModel;
    rightMediaSection: MediaElementModel;
    wideSpacing: boolean;
  } & ModuleSectionPropsModel
>;

const ImageVideoX2Block = (data: ImageVideoX2BlockModel) => {
  const { leftMediaSection, rightMediaSection, wideSpacing } = data.props;

  return (
    <ModuleSection data={data}>
      <div className="container flex justify-center">
        <div
          className={classNames(
            'flex w-full flex-col gap-6 py-3 lg:w-3/4 lg:flex-row lg:px-1.5',
            wideSpacing ? 'lg:gap-22' : 'lg:gap-3',
          )}
        >
          {leftMediaSection && (
            <div className="w-full lg:w-1/2">
              <MediaElement {...leftMediaSection} className="[&_.general-image]:aspect-video" />
            </div>
          )}
          {rightMediaSection && (
            <div className="w-full lg:w-1/2">
              <MediaElement {...rightMediaSection} className="[&_.general-image]:aspect-video" />
            </div>
          )}
        </div>
      </div>
    </ModuleSection>
  );
};

export default ImageVideoX2Block;
